import axiosInstance from "./axios";

export const getEventsData = async (id: any) => {
  try {
    return await axiosInstance.get(`event/${id}`);
  } catch (error) {
    throw error;
  }
};

export const getEventVisibility = async (id: any) => {
  try {
    return await axiosInstance.get(`event/${id}/visibility`);
  } catch (error) {
    throw error;
  }
};

export const getCollaborators = async (id: any, searchTerm: string) => {
  try {
    return await axiosInstance.post(`event/${id}/collaborators`, { search:searchTerm });
  } catch (error) {
    throw error;
  }
};

export const editEventsData = async (id: string, data: any) => {
  try {
    return await axiosInstance.put(`event/${id}`, data);
  } catch (error) {
    throw error;
  }
};

export const leaveUserService = async (id:string|undefined, payload:any) =>{
  try {
    return await axiosInstance.put(`event/${id}/leave`, payload)
  } catch (error) {
    throw error;
  }
}

export const removeUserService = async (id:string|undefined, payload:any) =>{
  try {
    return await axiosInstance.put(`event/${id}/remove-user`, payload)
  } catch (error) {
    throw error;
  }
}

export const transferUserService = async (id:string | undefined, payload:any) =>{
  try {
    return await axiosInstance.put(`event/${id}/transfer-ownership`, payload)
  } catch (error) {
    throw error;
  }
}
export const getInviteTeamMemberList = async (eventId:string,teamId:string) => {
  try {
    return await axiosInstance.get(`event/${eventId}/frequent-team-members/${teamId}`);
  } catch (error) {
    throw error;
  }
};

export const addInviteCollaborator = async (id: string, data: any) => {
  try {
    return await axiosInstance.post(`/event/${id}/invite`, data);
  } catch (error) {
    throw error;
  }
};

export const getEventInviteRoles = async () => {
  try {
    return await axiosInstance.get(`/event/roles`);
  } catch (error) {
    throw error;
  }
};

export const getLocation = async (payload:any) => {
  try {
    return await axiosInstance.post(`event/locations`,payload);
  } catch (error) {
    throw error;
  }
};